import AxiosInstance from "./axiosInstance";

export const listAllProduct = () => {
  return AxiosInstance.get("/product")
    .then((res) => {
      if (res.status === 200) return res.data;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
};
export const getProduct = (id) => {
  return AxiosInstance.get(`/product/${id}`)
    .then((res) => {
      if (res.status === 200) return res.data;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
};

export const createProduct = (data, files) => {
  var formdata = new FormData();
  formdata.append("data", JSON.stringify(data));
  if (files && files.length > 0) {
    files.forEach((file) => {
      formdata.append(`files`, file);
    });
  }
  return AxiosInstance.post("/product", formdata, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
    .then((res) => {
      if (res.status === 200) return res.data;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
};
export const deleteProduct = (id) => {
  return AxiosInstance.delete(`/product/${id}`)
    .then((res) => {
      if (res.status === 200) return res.data;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
};

export const updateProduct = (id, data, files) => {
  var formdata = new FormData();
  formdata.append("data", JSON.stringify(data));
  if (files && files.length > 0) {
    files.forEach((file) => {
      formdata.append(`files`, file);
    });
  }
  return AxiosInstance.patch(`/product/${id}`, formdata, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
    .then((res) => {
      if (res.status === 200) return res.data;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
};

export const listSearchedProduct = (search) => {
  return AxiosInstance.get(`/product/search?query=${search}`)
    .then((res) => {
      if (res.status === 200) return res.data;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
};
export const getProductReview = (id) => {
  return AxiosInstance.get(`/review/product/${id}`)
    .then((res) => {
      if (res.status === 200) return res.data;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
};
